var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18418_78156)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18418_78156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 -2.66699H-8V34.6667H48V-2.66699Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.57 8.73389L13.173 13.6675H18.3605L14.1637 16.7166L15.7668 21.6504L11.57 18.6012L7.37313 21.6504L8.97612 16.7166L4.7793 13.6675H9.96684L11.57 8.73389Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6751 25.1431L20.1012 23.9996L18.5275 25.143L19.1285 23.293L17.5547 22.1495H19.5L20.1012 20.2993L20.7025 22.1495H22.6477L21.0739 23.2929L21.6751 25.1431Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7804 19.4921H23.8352L23.2341 21.3421L22.633 19.4922L20.6875 19.4921L22.2615 18.3486L21.6602 16.4985L23.2341 17.6418L24.8079 16.4985L24.2067 18.3486L25.7804 19.4921Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7804 12.5069L24.2067 13.6504L24.8078 15.5004L23.2341 14.3571L21.6602 15.5006L22.2615 13.6503L20.6875 12.5071L22.6331 12.5069L23.2341 10.6567L23.8352 12.5069H25.7804Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.675 6.85607L21.0739 8.70625L22.6476 9.84955L20.7024 9.84966L20.101 11.7L19.4999 9.84955L17.5547 9.84977L19.1285 8.70614L18.5274 6.85596L20.101 7.99947L21.675 6.85607Z",
    fill: "#FFDA44"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18418_78156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18418_78156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 36.75,
    fill: "white",
    transform: "translate(-8 -2.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.a34bee16f1c00f6ecb70ae5fc5a56687.svg";
export { ForwardRef as ReactComponent };